/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import { LOADER_STATUS, SAVE_TOTAL_PAGES, SET_TABLE_DATA, SET_ENTITY_LIST, SET_SELECTED_ENTITY } from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  tableData: [],
  totalPages: 1,
  entityList: [],
  selectedEntity: "",
};

/* eslint-disable default-case, no-param-reassign */
const gstr8UploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case SET_TABLE_DATA:
      return {
        ...state,
        tableData: action.tableData,
      };
    case SAVE_TOTAL_PAGES:
      return {
        ...state,
        totalPages: action.pages,
      };
    case SET_ENTITY_LIST:
      return {
        ...state,
        entityList: action.payload,
      };
    case SET_SELECTED_ENTITY:
      return {
        ...state,
        selectedEntity: action.payload,
      };
    default:
      return state;
  }
};

export default gstr8UploadReducer;
